/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Carriers API
 * Carrier-facing API for the carrier portal (carriers.freightsimple.com).  Authentication: a carrier opens a permanent signed login link, exchanges it for a session token, and presents that token as a bearer on every other call. `CarrierPortalAuthenticationFilter` validates the session and scopes each request to one carrier. Operations use `security: []` (no Micronaut JWT) — the filter is the authenticator, the same model the agents API uses.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface ShipmentDocumentContent
 */
export interface ShipmentDocumentContent {
  /**
   *
   * @type {string}
   * @memberof ShipmentDocumentContent
   */
  fileName: string;
  /**
   *
   * @type {string}
   * @memberof ShipmentDocumentContent
   */
  base64Content: string;
}

/**
 * Check if a given object implements the ShipmentDocumentContent interface.
 */
export function instanceOfShipmentDocumentContent(
  value: object,
): value is ShipmentDocumentContent {
  if (!("fileName" in value) || value["fileName"] === undefined) return false;
  if (!("base64Content" in value) || value["base64Content"] === undefined)
    return false;
  return true;
}

export function ShipmentDocumentContentFromJSON(
  json: any,
): ShipmentDocumentContent {
  return ShipmentDocumentContentFromJSONTyped(json, false);
}

export function ShipmentDocumentContentFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ShipmentDocumentContent {
  if (json == null) {
    return json;
  }
  return {
    fileName: json["fileName"],
    base64Content: json["base64Content"],
  };
}

export function ShipmentDocumentContentToJSON(
  json: any,
): ShipmentDocumentContent {
  return ShipmentDocumentContentToJSONTyped(json, false);
}

export function ShipmentDocumentContentToJSONTyped(
  value?: ShipmentDocumentContent | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    fileName: value["fileName"],
    base64Content: value["base64Content"],
  };
}
